import S from 'common/service/sanctuary';
import React from 'react';
import { compose } from 'ramda';
import { node, arrayOf, element, bool, oneOfType } from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import classnames from 'classnames';
import withLoading from 'common/mdc/wrappers/withLoading';
import Button from 'common/mdc/button';
import { Error } from 'common/mdc/form';
import Toolbar, { ToolbarRow, ToolbarSection, ALIGN_START, ALIGN_END } from '../toolbar';
import { selectors, actions as stepperActions } from './state';

const messages = defineMessages({
  back: {
    id: 'stepper.action.back',
    defaultMessage: 'Back',
  },
});

const StepperContent = ({
  className,
  title,
  toolbar,
  tools,
  children,
  hasPreviousStep,
  loading,
  loadingComponent,
  actions,
  back,
  onSubmit,
  error,
}) => (
  <form
    onSubmit={(e) => {
      e.preventDefault();
      onSubmit();
    }}
    className={classnames(
      'mdc-card',
      'mdc-stepper__content',
      { 'mdc-stepper__content--loading': loading },
      className,
    )}
  >
    {loadingComponent}
    {(title || tools) && (
      <Toolbar>
        <ToolbarRow className="mdc-toolbar__row-48">
          {title &&
          <ToolbarSection align={ToolbarSection.ALIGN_START} shrink>
            <span className="mdc-toolbar__title">
              {title}
            </span>
          </ToolbarSection>}
          {tools &&
          <ToolbarSection align={title ? ToolbarSection.ALIGN_END : ToolbarSection.ALIGN_START}>
            {tools}
          </ToolbarSection>}
        </ToolbarRow>
        {toolbar}
      </Toolbar>
    )}
    {error && <Error>{error}</Error>}
    <section className="mdc-card__content">
      {children}
    </section>
    <section className="mdc-card__actions">
      <Toolbar>
        <ToolbarRow className="mdc-toolbar__row-48">
          <ToolbarSection align={ALIGN_START} shrink>
            <Button type="button" disabled={!hasPreviousStep} onClick={() => back()}>
              <FormattedMessage {...messages.back} />
            </Button>
          </ToolbarSection>
          <ToolbarSection align={ALIGN_END}>
            {React.Children.map(
              actions,
              action => React.cloneElement(action, {
                className: classnames(
                  action.props.className,
                  'mdc-card__action',
                ),
              }),
            )}
          </ToolbarSection>
        </ToolbarRow>
      </Toolbar>
    </section>
  </form>
);

StepperContent.propTypes = {
  children: node.isRequired,
  actions: arrayOf(node),
  title: node,
  hasPreviousStep: bool,
};

StepperContent.defaultProps = {
  title: undefined,
  actions: [],
  hasPreviousStep: false,
};

export default compose(
  connect(
    state => ({
      hasPreviousStep: selectors.hasPreviousStep(state),
      error: S.maybeToNullable(S.map(S.prop('error'), selectors.getCurrentStep(state))),
    }),
    {
      back: stepperActions.back,
    },
  ),
  withLoading(),
)(StepperContent);
